import axios from 'axios';

import BaseService from "./BaseService";
import LogUtils from "../utils/LogUtils";
import MsgUtils from "../utils/MsgUtils";
import settings from "../settings/settings";

class AgentInspectionStatusService extends BaseService {

   constructor() {
      super();
      this.TAG = "AgentInspectionStatusService";

      this.logUtils = new LogUtils();
      this.msgUtils = new MsgUtils();
   }

   async getAgentInspectionStatus() {
      let agentInspectionStatus = {};

      try {
         const response = this.getResponse(await axios(this.getBasicHttpRequest(
            this.HTTP_METHODS.GET,
            `${settings.MANAGEMENT_SERVICE_URL}/agent-inspection-status`,
            this.getDefaultHeaders(true)
         )));

         if (response.status !== 1) {
            return {
               status: 0,
               msg: "Não foi possível retornar a lista de status da inspeção."
            };
         }

         if (!response.data) {
            return {
               status: -1,
               msg: "Não foi possível retornar a lista de status da inspeção."
            };
         }

         agentInspectionStatus = response.data;

      } catch (err) {
         this.logUtils.logErrorMsg(this.TAG, "Unabled to getAgentInspectionStatus", err);

         return {
            status: -2,
            msg: this.parseError(err)
         };
      }

      return {
         status: 1,
         msg: "A lista de status da inspeção foi retornada com sucesso.",
         data: agentInspectionStatus
      };
   }

}

export default AgentInspectionStatusService;